<div ng-if="false">
    <!--
    <div class="d-none row hide-mobile">
        <div class="col-12 col-sm-6 col-md col-lg col-xl g-s-b" *ngFor="let slide of slides;  index as i">
            <img loading="lazy" [src]="slide?.icon" [alt]="slide.icon_alt ? slide.icon_alt : slide.title" class="img-fluid d-block mx-auto"
                style="max-height: 107px;" />
            <div class="getting-started-block-header w-100 shadow rounded-pill d-flex align-items-center py-1 px-1">
                <div class="container-fluid p-0">
                    <div class="row">
                        <div class="col-auto">
                            <div class="d-flex align-items-center justify-content-center getting-started-block-counter">
                                <h4 class="m-0 text-white">{{ (i + 1) }}</h4>
                            </div>
                        </div>
                        <div class="col text-center d-flex align-items-center justify-content-center">
                            <h4 class="text-center m-0">{{ slide?.title }}</h4>
                        </div>
                        <div class="col-auto">
                            <div
                                class="d-flex align-items-center justify-content-center getting-started-block-counter" style="opacity: 0;">
                                <h4 class="m-0 text-white">1</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <p class="text-center mt-5 font-size-16" [innerHTML]="slide.description | safeHtml"></p>
        </div>
    </div>

    <div class="d-none row show-mobile">
        <div class="col-12 responsive-partial-overflow-swiper">
            <swiper [config]="responsivePartialOverflowConfig" (swiper)="onProgressSwiper($event)" class="w-100 why-swiper">
                <ng-template swiperSlide *ngFor="let slide of slides;  index as i">
                    <div class="w-100 h-100 d-flex flex-column">
                        <img loading="lazy" [src]="slide?.icon" [alt]="slide.icon_alt ? slide.icon_alt : slide.title" class="img-fluid d-block mx-auto"
                            style="max-height: 107px;" />
                        <div
                            class="getting-started-block-header w-100 shadow rounded-pill d-flex align-items-center py-1 px-1">
                            <div class="container-fluid p-0">
                                <div class="row">
                                    <div class="col-auto">
                                        <div
                                            class="d-flex align-items-center justify-content-center getting-started-block-counter">
                                            <h4 class="m-0 text-white">{{ (i + 1) }}</h4>
                                        </div>
                                    </div>
                                    <div class="col text-center d-flex align-items-center justify-content-center">
                                        <h4 class="text-center m-0">{{ slide?.title }}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <p class="text-center mt-5 font-size-16" [innerHTML]="slide.description | safeHtml"></p>
                    </div>
                </ng-template>
            </swiper>
        </div>
    </div>
    -->
</div>

<div class="row">
    <div class="col-12 responsive-partial-overflow-swiper">
        <swiper [config]="responsivePartialOverflowConfig" (swiper)="onProgressSwiper($event)" class="w-100 why-swiper">

            <ng-template swiperSlide *ngFor="let slide of slides, index as i">
                <div class="w-100 h-100 d-flex flex-column">
                    <div class="card h-100 shadow-sm flex-grow-1">
                        <div class="card-img-top pt-5" >
                            <img loading="lazy" *ngIf="slide?.icon" [src]="slide?.icon"
                                 [title]="slide.icon_alt ? slide.icon_alt : slide.title | stripHtml"
                                 [alt]="slide.icon_alt ? slide.icon_alt : slide.title | stripHtml"
                                 class="img-fluid d-block mx-auto icon-image" />
                        </div>
                        <div class="card-body pt-0">
                            <h4 class="text-center mx-auto d-block text-dark font-size-18 mt-0"
                                [innerHTML]="i+1 + '. ' + slide?.title | safeHtml">
                            </h4>
                            <p class="text-center mt-5 font-size-14 text-dark"
                               [innerHTML]="slide.description | safeHtml"></p>
                        </div>
                    </div>
                </div>
            </ng-template>

        </swiper>
    </div>
</div>